"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _freight = require("@/api/freight");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultRole = {
  name: '',
  type: 0,
  appoint: 0,
  sort: 0,
  region: [{
    first: 1,
    first_price: 0,
    continue: 1,
    continue_price: 0,
    city_id: [],
    city_ids: []
  }],
  undelivery: 0,
  free: [],
  undelives: {},
  city_id3: []
};
var kg = '重量（kg）';
var m = '体积（m³）';
var statusMap = [{
  title: '首件',
  title2: '续件',
  title3: '最低购买件数'
}, {
  title: "\u9996\u4EF6".concat(kg),
  title2: "\u7EED\u4EF6".concat(kg),
  title3: "\u6700\u4F4E\u8D2D\u4E70".concat(kg)
}, {
  title: "\u9996\u4EF6".concat(m),
  title2: "\u7EED\u4EF6".concat(m),
  title3: "\u6700\u4F4E\u8D2D\u4E70".concat(m)
}];
var _default = {
  name: 'CreatTemplates',
  props: {
    tempId: {
      type: Number,
      default: 0
    },
    componentKey: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      loading: false,
      rules: {
        name: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }],
        free: [{
          type: 'array',
          required: true,
          message: '请至少添加一个地区',
          trigger: 'change'
        }],
        appoint: [{
          required: true,
          message: '请选择是否指定包邮',
          trigger: 'change'
        }],
        undelivery: [{
          required: true,
          message: '请选择是否指定区域不配送',
          trigger: 'change'
        }],
        type: [{
          required: true,
          message: '请选择计费方式',
          trigger: 'change'
        }],
        region: [{
          required: true,
          message: '请选择活动区域',
          trigger: 'change'
        }],
        city_id3: [{
          type: 'array',
          required: true,
          message: '请至少选择一个地区',
          trigger: 'change'
        }]
      },
      nodeKey: 'city_id',
      props: {
        children: 'children',
        label: 'name',
        value: 'city_id',
        multiple: true
      },
      dialogVisible: false,
      ruleForm: Object.assign({}, defaultRole),
      listLoading: false,
      cityList: [],
      columns: {
        title: '首件',
        title2: '续件',
        title3: '最低购买件数'
      }
    };
  },
  watch: {
    componentKey: {
      handler: function handler(val, oldVal) {
        if (val) {
          this.getInfo();
        } else {
          this.ruleForm = {
            name: '',
            type: 0,
            appoint: 0,
            sort: 0,
            region: [{
              first: 1,
              first_price: 0,
              continue: 1,
              continue_price: 0,
              city_id: [],
              city_ids: []
            }],
            undelivery: 0,
            free: [],
            undelives: {},
            city_id3: []
          };
        }
      }
      // immediate: true
    }
  },
  mounted: function mounted() {
    this.getCityList();
    if (this.tempId > 0) this.getInfo();
  },
  methods: {
    resetForm: function resetForm(formName) {
      this.$msgbox.close();
      this.$refs[formName].resetFields();
    },
    onClose: function onClose(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    },
    confirmEdit: function confirmEdit(row, index) {
      row.splice(index, 1);
    },
    changeRegion: function changeRegion(value) {
      console.log(value);
    },
    changeRadio: function changeRadio(num) {
      this.columns = Object.assign({}, statusMap[num]);
    },
    // 添加配送区域
    addRegion: function addRegion(region) {
      region.push(Object.assign({}, {
        first: 1,
        first_price: 1,
        continue: 1,
        continue_price: 0,
        city_id: [],
        city_ids: []
      }));
    },
    addFree: function addFree(Free) {
      Free.push(Object.assign({}, {
        city_id: [],
        number: 1,
        price: 0.01,
        city_ids: []
      }));
    },
    // 详情
    getInfo: function getInfo() {
      var _this = this;
      this.loading = true;
      (0, _freight.templateDetailApi)(this.tempId).then(function (res) {
        _this.dialogVisible = true;
        var info = res.data;
        _this.ruleForm = {
          name: info.name,
          type: info.type,
          appoint: info.appoint,
          sort: info.sort,
          region: info.region,
          undelivery: info.undelivery,
          free: info.free,
          undelives: info.undelives,
          city_id3: info.undelives.city_ids || []
        };
        // this.ruleForm.region.map(item => {
        //   this.$set(item, 'city_ids', item.city_ids)
        //   this.$set(item, 'city_id', item.city_ids.splice(0, 1))
        // })
        // this.ruleForm.free.map(item => {
        //   this.$set(item, 'city_ids', item.city_ids)
        //   this.$set(item, 'city_id', item.city_ids.splice(0, 1))
        // })
        _this.changeRadio(info.type);
        // this.$refs.changeType.click(info.type)
        // this.$refs.refid.click();
        _this.loading = false;
      }).catch(function (res) {
        // this.$message.error(res.message)
        _this.loading = false;
      });
    },
    // 列表
    getCityList: function getCityList() {
      var _this2 = this;
      (0, _freight.cityList)().then(function (res) {
        _this2.cityList = res.data;
      }).catch(function (res) {
        // this.$message.error(res.message)
      });
    },
    change: function change(idBox) {
      idBox.map(function (item) {
        var ids = [];
        if (item.city_ids.length === 0) return;
        item.city_ids.map(function (j) {
          // j.splice(0, 1)
          ids.push(j[1]);
        });
        item.city_id = ids;
      });
      return idBox;
    },
    changeOne: function changeOne(idBox) {
      var city_ids = [];
      if (idBox.length === 0) return;
      idBox.map(function (item) {
        // item.splice(0, 1)
        city_ids.push(item[0]);
      });
      return city_ids;
    },
    onsubmit: function onsubmit(formName) {
      var _this3 = this;
      // this.ruleForm.region = this.change(this.ruleForm.region)
      // this.ruleForm.free = this.change(this.ruleForm.free)
      // this.ruleForm.undelives.city_id = this.changeOne(this.ruleForm.city_id3)
      var data = {
        name: this.ruleForm.name,
        type: this.ruleForm.type,
        appoint: this.ruleForm.appoint,
        sort: this.ruleForm.sort,
        region: this.change(this.ruleForm.region),
        undelivery: this.ruleForm.undelivery,
        free: this.change(this.ruleForm.free),
        undelives: {
          city_id: this.changeOne(this.ruleForm.city_id3)
        }
      };
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.tempId === 0 ? (0, _freight.templateCreateApi)(data).then(function (res) {
            _this3.$message.success(res.message);
            setTimeout(function () {
              _this3.$msgbox.close();
            }, 500);
            setTimeout(function () {
              _this3.$emit('getList');
              _this3.$refs[formName].resetFields();
            }, 600);
          }).catch(function (res) {
            // this.$message.error(res.message)
          }) : (0, _freight.templateUpdateApi)(_this3.tempId, data).then(function (res) {
            _this3.$message.success(res.message);
            setTimeout(function () {
              _this3.$msgbox.close();
            }, 500);
            setTimeout(function () {
              _this3.$emit('getList');
              _this3.$refs[formName].resetFields();
            }, 600);
          }).catch(function (res) {
            // this.$message.error(res.message)
          });
        } else {
          return false;
        }
      });
    }
  }
};
exports.default = _default;